import { IconProps } from "ztypes/icon-props";

const IconCheck: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0761 2.86223C15.4666 3.25275 15.4666 3.88592 15.0761 4.27644L6.21495 13.1376C5.82442 13.5281 5.19126 13.5281 4.80073 13.1376L0.923997 9.26082C0.533472 8.87029 0.533472 8.23713 0.923997 7.8466C1.31452 7.45608 1.94769 7.45608 2.33821 7.8466L5.50784 11.0162L13.6618 2.86223C14.0524 2.4717 14.6855 2.4717 15.0761 2.86223Z"
        fill="#0068FF"
      />
    </svg>
  );
};

export default IconCheck;
